import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const RoundedCheckmarkIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 13),
    strokeWidth: "2",
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /*#__PURE__*/jsx("path", {
      d: "M2.6 6.7264 5.6574 9.75l5.3926-6.5"
    })
  });
};

export { RoundedCheckmarkIcon };
//# sourceMappingURL=checkmark.rounded.js.map
